import React, { useState } from 'react';
import {
  AddFileIcon,
  AddImageIcon,
  AddVideoIcon,
  LinkIcon,
  SoundIcon,
  TextIcon,
} from '@/icons';
import { AddDrawingIcon } from '@/icons/AddDrawingIcon';
import { UserContentType } from '@/types';
import { useDrawingContext } from '@/contexts/DrawingContext';
const FloatingButton = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const { activateNoteArea } = useDrawingContext();
  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const addNote = (userContentType: UserContentType) => {
    activateNoteArea(userContentType);
  };

  return (
    <div style={styles.container}>
      {/* Açılır Menü */}
      {isOpen && (
        <div style={styles.menu}>
          {/* <button
            style={styles.menuItem}
            onClick={() => addNote(UserContentType.Image)}
            className="obro-btn obro-secondary-btn add-note-btn"
          >
            <AddImageIcon color="#fff" />
            <span>Resim Ekle</span>
          </button>
          <button
            style={styles.menuItem}
            onClick={() => addNote(UserContentType.Video)}
            className="obro-btn obro-secondary-btn add-note-btn"
          >
            <AddVideoIcon color="#fff" />
            <span>Video Ekle</span>
          </button>
          <button
            style={styles.menuItem}
            onClick={() => addNote(UserContentType.Sound)}
            className="obro-btn obro-secondary-btn add-note-btn"
          >
            <SoundIcon color="#fff" />
            <span>Ses Ekle</span>
          </button> */}
          {/* <button
            style={styles.menuItem}
            onClick={() => addNote(UserContentType.File)}
            className="obro-btn obro-secondary-btn add-note-btn"
          >
            <AddFileIcon color="#fff"></AddFileIcon>
            <span>Dosya Ekle</span>
          </button> */}
          <button
            style={styles.menuItem}
            onClick={() => addNote(UserContentType.Link)}
            className="obro-btn obro-secondary-btn add-note-btn"
          >
            <LinkIcon className={undefined}></LinkIcon>
            <span>Link Ekle</span>
          </button>
          <button
            style={styles.menuItem}
            onClick={() => addNote(UserContentType.Text)}
            className="obro-btn obro-secondary-btn add-note-btn"
          >
            <TextIcon color="#fff"></TextIcon>
            <span>Yazı Ekle</span>
          </button>
          <button
            style={styles.menuItem}
            onClick={() => addNote(UserContentType.Drawing)}
            className="obro-btn obro-secondary-btn add-note-btn"
          >
            <AddDrawingIcon color="#fff"></AddDrawingIcon>
            <span>Çizim Ekle</span>
          </button>
        </div>
      )}

      {/* Floating Button */}
      <button
        className="obro-btn obro-light-gray-btn add-note-btn"
        onClick={toggleMenu}
      >
        {children}
      </button>
    </div>
  );
};

const styles: { [key: string]: React.CSSProperties } = {
  container: {
    position: 'relative',
  },
  menu: {
    position: 'absolute',
    display: 'flex',
    flexDirection: 'column',
    gap: '10px',
    bottom: '70px',
    left: '50%',
    transform: 'translateX(-50%)',
    backgroundColor: 'white',
    border: '1px solid #ddd',
    borderRadius: '8px',
    boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.2)',
    padding: '10px',
    width: '220px',
    zIndex: 1,
  },
};

export default FloatingButton;
